import { render, staticRenderFns } from "./tableHeader.vue?vue&type=template&id=ed61b8a8&"
import script from "./tableHeader.vue?vue&type=script&lang=js&"
export * from "./tableHeader.vue?vue&type=script&lang=js&"
import style0 from "./tableHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports